import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "skill-container"
};
const _hoisted_2 = {
  key: 0,
  class: "learned-status"
};
const _hoisted_3 = {
  key: 1,
  class: "learned-status inactive"
};
const _hoisted_4 = {
  key: 2,
  class: "learned-status inactive"
};
const _hoisted_5 = {
  key: 0,
  class: "path-desc"
};
const _hoisted_6 = {
  class: "skilled-box"
};
const _hoisted_7 = {
  key: 0,
  class: "skilled-path"
};
const _hoisted_8 = {
  key: 0,
  class: "separator"
};
const _hoisted_9 = {
  key: 1,
  class: "over-limit-box"
};
const _hoisted_10 = {
  class: "over-limit-path"
};
import { ref, computed, watch, inject } from 'vue';
import { ElRow } from 'element-plus';
import store from '@/store';
import { inApostleType, isValid, parseToCostDesc } from '@/tools/utils';
import 'element-plus/es/components/progress/style/css'; // pre-declaration

export default {
  __name: 'SectsSkillPreviewCard',
  props: {
    skill: {
      type: Object,
      required: true
    }
  },
  emits: ['closePopper'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const data = ref(null); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    }); // functions

    const getSkillDesc = item => {
      const isPrivate = item.is_private ? '秘传' : '公开';
      const skillType = isValid(item.skill_type) ? item.skill_type.desc : '不明';
      const conventional = item.conventional ? '常规施法' : '构筑施法';
      const powerType = isValid(item.power_type) ? item.power_type.desc : '不明';
      let skillDesc = `${powerType} · ${skillType} · ${conventional}`;

      if (inApostleType(userType.value)) {
        return `${isPrivate} · ${skillDesc} · 神秘${item.mysterious_level}`;
      }

      return skillDesc;
    }; // post-declaration


    const selectedSkill = inject('selectedSkill'); // watcher

    watch(() => props.skill, newValue => data.value = newValue, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", null, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), data.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [data.value.learned ? (_openBlock(), _createElementBlock("text", _hoisted_2, "已掌握")) : data.value.inactive && data.value.pre_skill ? (_openBlock(), _createElementBlock("text", _hoisted_3, " 尚未掌握《" + _toDisplayString(`${data.value.pre_skill.degree}级 - ${data.value.pre_skill.name}`) + "》 ", 1)) : data.value.pre_skill ? (_openBlock(), _createElementBlock("text", _hoisted_4, " 需求前置《" + _toDisplayString(`${data.value.pre_skill.degree}级 - ${data.value.pre_skill.name}`) + "》 ", 1)) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(getSkillDesc(data.value)), 1)])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [data.value.skilled_path || data.value.over_limit_path ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [data.value.skilled_path ? (_openBlock(), _createElementBlock("text", _hoisted_7, " 专精途径：" + _toDisplayString(data.value.skilled_path), 1)) : _createCommentVNode("", true)]), data.value.over_limit_path ? (_openBlock(), _createElementBlock("text", _hoisted_8, "/")) : _createCommentVNode("", true), data.value.over_limit_path ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("text", _hoisted_10, " 超限途径：" + _toDisplayString(data.value.over_limit_path), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }), _unref(isValid)(data.value.timing_type) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[1] || (_cache[1] = _createTextVNode("发动时机    ", -1)), _createElementVNode("b", null, _toDisplayString(data.value.timing_type.desc), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(data.value.cooldown) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[2] || (_cache[2] = _createTextVNode("技能冷却    ", -1)), _createElementVNode("b", null, _toDisplayString(data.value.cooldown.desc), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(data.value.cost) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 2,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[3] || (_cache[3] = _createTextVNode("技能消耗    ", -1)), _createElementVNode("b", null, _toDisplayString(_unref(parseToCostDesc)(data.value['cost'])), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        class: "skill-desc"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(data.value['desc']), 1)]),
        _: 1
      }), _unref(isValid)(data.value.deep_desc) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 3,
        class: "skill-deep-desc"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(data.value['deep_desc']), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        class: "apostle-operator-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => {
            emits('closePopper');

            _unref(selectedSkill)(__props.skill);
          })
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 流派技能调整 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }

};